<div class="wrapper" [ngStyle]="{'height':height}">
  <canvas #myChart></canvas>
</div>
